import { render, staticRenderFns } from "./BlobImageViewer.vue?vue&type=template&id=2b48651b&scoped=true&"
import script from "./BlobImageViewer.vue?vue&type=script&lang=ts&"
export * from "./BlobImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./BlobImageViewer.vue?vue&type=style&index=0&id=2b48651b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48651b",
  null
  
)

export default component.exports